import React from 'react'
import { Box, Group } from '@mantine/core'
import { Column } from 'components/ui/ScrollableTable'
import TableHeaderCell from 'components/ui/TableHeaderCell'

type Props = {
  columns: Column[]
}

const ListHeader = ({ columns }: Props) => {
  return (
    <Group position="apart" sx={{ gap: 0 }} noWrap>
      {columns.map((column) => {
        const { dataPath, minWidth, maxWidth, width, flex, cellStyle, headerCellStyle } = column
        return (
          <Box
            key={`header-cell-${dataPath}`}
            style={{ minWidth, maxWidth, width, flex, ...cellStyle, ...headerCellStyle }}
          >
            <TableHeaderCell>{column.title}</TableHeaderCell>
          </Box>
        )
      })}
    </Group>
  )
}

export default ListHeader
